import { Directive, input } from '@angular/core';

@Directive({ selector: 'ng-template[typedTemplate]', standalone: true })
export class TypedTemplateDirective<TypeToken> {
  /** Type token used only for compile-time typing of `ng-template` context. */
  public readonly typedTemplate = input.required<TypeToken>();

  /** Angular template context type guard for `ng-template[typedTemplate]`. */
  public static ngTemplateContextGuard<TypeToken>(
    _dir: TypedTemplateDirective<TypeToken>,
    _ctx: unknown
  ): _ctx is TypeToken {
    return true;
  }
}
